const prefixName = '@queries/';

export const HAS_ERROR = `${prefixName}has_error`;
export const IS_LOADING = `${prefixName}is_loading`;
export const READ_ALL = `${prefixName}read_all`;
export const SET_LAST_UPDATE = `${prefixName}set_last_update`;
export const SET_QUERY_LOADING = `${prefixName}set_query_loading`;
export const SET_TABLE_DATA = `${prefixName}set_table_data`;
